import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ConsultationForm from "./ConsultationForm";
import { useTranslation } from "react-i18next";
const Consultation = () => {
  const { t } = useTranslation();
  const [showFrom, setShowForm] = useState(false);

  return (
    <>
      <button
        className=" bg-primary text-white p-2 px-3 font-bold text-sm  rounded-lg hover:scale-105 transition cursor-pointer"
        onClick={() => setShowForm(!showFrom)}
      >
        {/* التواصل مع مختص */}
        {t("mahsool_guide.contact_specialist")}
      </button>
      <AnimatePresence>
        {showFrom && (
          <motion.div
            initial={{ opacity: 0 }}
            exit={{ opacity: 0, transition: { duration: 0.3 } }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 h-full z-[99999] flex items-center justify-center overflow-x-hidden overflow-y-auto backdrop-blur-md bg-black/30"
          >
            <motion.div
              initial={{ y: 50 }}
              exit={{ y: 25, opacity: 0, transition: { duration: 0.1 } }}
              animate={{ y: 0 }}
              transition={{ duration: 0.2 }}
              className="w-[80%] lg:w-[28%]"
            >
              <ConsultationForm showFrom={showFrom} setShowForm={setShowForm} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Consultation;
